import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'InvoiceNumbering';
const ENDPOINT = `/invoice-numberings/`;

@Injectable({
    providedIn: 'root'
})
export class InvoiceNumberingService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
